export default {
  methods: {
    checkScroll (el) {
      return el.scrollHeight > el.clientHeight
    }
  }
}
